import { defineComponent as _defineComponent } from 'vue'
import DDos from '@/components/DDos.vue'
import Error from '@/components/Error.vue'
import Loader from '@/components/Loader.vue'
import ReLogin from '@/components/ReLogin.vue'
import Success from '@/components/Success/index.vue'
import Chat from '@/widgets/chat/ui/Chat.vue'
import '@ifr/form-questionnaire/dist/form-questionnaire.css'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return { __sfc: true,DDos, Error, Loader, ReLogin, Success, Chat }
}

})